import { Button, Dialog, Flex, Text } from "@chakra-ui/react";
import TableList from "./TableList";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";

// const DataLists = ({ items }) => {
//   return (
//     <DataList.Root orientation="horizontal" divideY="1px" maxW="md">
//       {items?.map((item) => (
//         <DataList.Item key={item.value} pt="2">
//           <DataList.ItemValue>{item.value}</DataList.ItemValue>
//           <DataList.ItemLabel>{item.label}</DataList.ItemLabel>
//         </DataList.Item>
//       ))}
//     </DataList.Root>
//   );
// };

const Modal = ({
  header,
  btLable,
  Content,
  isopen,
  items,
  onSelect,
  type,
  title,
  setIsOpen,
  Child,
  childData,
  size,
}) => {
  // const [open, setOpen] = useState(isopen ? true : false);
  const ismobile = useCheckMobileScreen();

  return (
    <Dialog.Root
      scrollBehavior="inside"
      // size={ismobile ? 'cover' : "md"}
      size={ismobile ? "sm" : size || "md"}
      // size={'xl'}
      lazyMount
      open={isopen}
      onOpenChange={(e) => setIsOpen && setIsOpen(e.open)}
      trapFocus={false}
    >
      <Dialog.Trigger />
      <Dialog.Backdrop />
      <Dialog.Positioner p={"10px"} alignItems={ismobile ? "center" : "start"}>
        {type === "list" ? (
          <Dialog.Content>
            <Dialog.CloseTrigger />
            <Dialog.Header>
              <Dialog.Title>{title}</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Flex direction={"column"} gap={2}>
                {items?.map((a, index) => (
                  <Button
                    variant={"ghost"}
                    onClick={(e) => onSelect({ item: a, index: index })}
                  >
                    <Flex w={"100%"} gap={"1rem"} pt={"0.5rem"} pb={"0.5rem"}>
                      <Text
                        w={"100%"}
                        textWrap={"wrap"}
                        textAlign={"left"}
                        truncate={true}
                      >
                        {`${a?.address1 ? a?.address1 : ""}${
                          a?.address2 ? ", " + a?.address2 : ""
                        }${a?.address3 ? ", " + a?.address3 : ""}`}
                      </Text>
                    </Flex>
                  </Button>
                ))}
              </Flex>
            </Dialog.Body>
            <Dialog.Footer />
          </Dialog.Content>
        ) : null}

        {type === "table" ? (
          <Dialog.Content>
            {/* <Dialog.CloseTrigger /> */}
            <Dialog.Header>
              <Dialog.Title>{title}</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              {items && items[0] ? (
                <TableList items={items} type={"simple"} />
              ) : (
                <Flex gap={"1rem"}>
                  <Text textWrap={"wrap"} textAlign={"left"}>
                    Empty
                  </Text>
                </Flex>
              )}
            </Dialog.Body>
            {/* <Dialog.Footer /> */}
          </Dialog.Content>
        ) : null}

        {!type ? (
          <Dialog.Content>
            <Dialog.CloseTrigger />
            <Dialog.Header>
              <Dialog.Title>{title}</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Child
                setIsOpen={setIsOpen}
                itemData={childData?.itemData}
                type={childData?.type}
                setIsLoading={childData?.setIsLoading}
              />
            </Dialog.Body>
            {/* <Dialog.Footer /> */}
          </Dialog.Content>
        ) : null}
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export default Modal;
